export default __webpack_public_path__ + "static/media/internationalBG.a43c9b7d.jpg";